import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Trailer, TrailerUpdateOption } from 'src/app/services/app/trailer.service';
import { Yard, YardUpdateOption } from 'src/app/services/app/yard.service';

export class YardUpdate{
  update: YardUpdateOption;
  yard: Yard;
}
export class TrailerUpdate{
  update: TrailerUpdateOption;
  trailer: Trailer;
}
@Component({
  selector: 'location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {

  @Input() yard: Yard;
  @Input() availableTrailers: Trailer[];
  @Output() yardUpdate: EventEmitter<YardUpdate> = new EventEmitter();
  @Output() trailerUpdate: EventEmitter<TrailerUpdate> = new EventEmitter();
  search: string;
  showSearch: boolean = false;
  editToggle: boolean = false;
  dropToggle: boolean = false;

  selectedTrailer: Trailer;

  constructor(){

  }

  
  hideResults(){
    setTimeout(() =>{
      this.showSearch = false;
    }, 150);
  }

  toggleDrop(){
    if(this.dropToggle){
      this.dropToggle = false;
    }else{
      this.dropToggle = true;
    }
  }

  toggleEdit(){
    if(this.editToggle){
      this.editToggle = false;
      if(this.yard.status === 'EMPTY'){
        this.yard.trailer = new Trailer();
        this.yard.trailerId = null;
      }
    }else{
      this.editToggle = true;
      if(this.selectedTrailer){
        this.yard.trailer = this.selectedTrailer;
        this.yard.trailerId = this.selectedTrailer.id;
      }
    }
  }

  async onSelectionChange(){
    
    this.yard.trailer = this.selectedTrailer;
    this.yard.trailerId = this.selectedTrailer.id;
  }

  async clearTrailer(){
    this.yard.trailer = new Trailer();
    this.yard.trailerId = null;
    this.selectedTrailer = new Trailer();
  }

  async attachTrailer(){
    this.yard.trailer = this.selectedTrailer;
    this.yard.trailerId = this.selectedTrailer.id;
    const update = { update: YardUpdateOption.ASSIGN, yard: this.yard };
    this.yardUpdate.emit(update);
  }

  async saveTrailer(){
    const update = { update: TrailerUpdateOption.UPDATE, trailer: this.yard.trailer };
    this.trailerUpdate.emit(update);
  }


  async removeItem(){
    if(this.yard.trailer !== null){
      const update = { update: YardUpdateOption.UNASSIGN, yard: this.yard };
      this.yardUpdate.emit(update);
    }
 
   
  }

  async saveChanges(){
    console.log('save changes');
    const update = { update: YardUpdateOption.UPDATE, yard: this.yard };
    this.yardUpdate.emit(update);
    this.toggleEdit();
    
  }

  ngOnInit(): void {
    
    
  }
  

}
